import type { IconProps } from 'src/types/icons';

const ChevronLeftIcon = (props: IconProps) => (
  <svg
    {...props}
    aria-hidden="true"
    fill="none"
    height="14"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2.5"
    viewBox="0 0 24 24"
    width="14"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15 18l-6-6 6-6" />
  </svg>
);

export default ChevronLeftIcon;

